import React, { memo } from "react";
import { Button } from "antd";

import styles from "./styles.module.scss";
import uHubsIcon from "assets/images/uHubs.png";
import laptopBlueIcon from "assets/images/laptopBlue.webp";
import phoneBlueIcon from "assets/images/phoneBlue.webp";
import uHubsPlusIcon from "assets/images/uHubsPlus.png";
import uHubsAppIcon from "assets/images/uApp.png";

const PricingCards: React.FunctionComponent<any> = () => {
	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.headerIcon}>
					<img src={uHubsIcon} alt="uhubs" />
				</div>
				<div className={styles.headerTitle}>
					{"A great home for your membership community"}
				</div>
				<div className={styles.smallIcon}>
					<img src={laptopBlueIcon} alt="laptopIcon" />
				</div>
				<div className={styles.listedItems}>
					<div>{"Branded Web Platform"}</div>
					<div>{"Full Ugenie Feature List"}</div>
					<div>{"For communities of 0-500"}</div>
					<div>{"Initial Consultation"}</div>
					<div>{"Community Manager Onboarding"}</div>
					<div>{"Ongoing Support"}</div>
				</div>
				<div className={styles.price}>
					<div className={styles.boldNumber}>{"£35"}</div>
					<div className={styles.lightText}>{"per month"}</div>
				</div>
				<div className={styles.button}>
					<Button type={"primary"}>{"Launch your free trial"}</Button>
				</div>
			</div>
			<div className={styles.card}>
				<div
					className={styles.headerIcon}
					style={{ position: "relative" }}
				>
					<img src={uHubsPlusIcon} alt="uhubsPlus" />
					{/* <span
						style={{
							fontSize: 40,
							position: "absolute",
							color: "#009BB9",
							right: 20,
							top: 46,
							fontFamily: "'Avenir-Light', sans-serif",
						}}
					>
						+
					</span> */}
				</div>
				<div className={styles.headerTitle}>
					{"Perfect for community businesses to grow"}
				</div>
				<div className={styles.smallIcon}>
					<img
						src={laptopBlueIcon}
						alt="laptopIcon"
						style={{ width: 53, height: 51 }}
					/>
					<img
						src={phoneBlueIcon}
						style={{
							position: "relative",
							right: 16,
							width: 60,
							height: 60,
						}}
						alt="phoneBlueIcon"
					/>
				</div>
				<div className={styles.listedItems}>
					<div>{"Branded Web + Ugenie App Access"}</div>
					<div>{"Full Ugenie Feature List"}</div>
					<div>{"For communities up to 500"}</div>
					<div>{"Initial Consultation"}</div>
					<div>{"Community Manager Onboarding"}</div>
					<div>{"Dedicated Account Manager"}</div>
				</div>
				<div className={styles.price}>
					<div className={styles.boldNumber}>{"£65"}</div>
					<div className={styles.lightText}>{"per month"}</div>
				</div>
				<div className={styles.button}>
					<Button type={"primary"}>{"Launch your free trial"}</Button>
				</div>
			</div>
			<div className={styles.card}>
				<div className={styles.headerIcon}>
					<img src={uHubsAppIcon} alt="uhubsApp" />
				</div>
				<div className={styles.headerTitle}>
					{"Your own branded community app made easy."}
				</div>
				<div className={styles.smallIcon}>
					<img src={phoneBlueIcon} alt="laptopIcon" />
				</div>
				<div className={styles.listedItems}>
					<div>{"Own Branded iOS + Android App"}</div>
					<div>{"Full Ugenie Feature List"}</div>
					<div>{"Ugenie Community Dashboard"}</div>
					<div>{"Website Integration"}</div>
					<div>{"Community Migration Support"}</div>
					<div>{"Dedicated Ugenie Expert Support"}</div>
				</div>
				<div className={styles.price}>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							textAlign: "center",
						}}
					>
						<div
							className={styles.boldNumber}
							style={{ marginRight: 8 }}
						>
							{"£65"}
						</div>
						<div className={styles.lightText}>{"per month"}</div>
					</div>
					<div className={styles.lightText}>
						{"+ £3,500 set-up fee"}
					</div>
				</div>
				<div className={styles.button}>
					<Button type={"primary"}>
						{"Enquire about White Label"}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default memo(PricingCards);
